import { Controller } from 'stimulus';

class Filter extends Controller {

  initialize() {
    // console.log('filter controller initialize');
    document.body.addEventListener('click', this.closeMenu.bind(this), true);
  }
  connect() { }
  
  closeOthers({ detail: { content } }) {
    Array.from(this.filtersTargets).forEach((dropdown) => {
      const button = dropdown.querySelector('button');
      const options = dropdown.querySelector('ul');
      if (content !== button) {
        options.classList.add('hidden')
        button.classList.remove('active')
      };
    });
  }
  closeMenu(e) {
    const closestMenu = e.target.closest('ul[data-select-target=options]');
    if(!closestMenu) {
      this.closeOthers({ detail: { content: e.target } });
      document.body.removeEventListener('click', this.closeMenu, true);
    }
  }
  filterToggle(e) {
    e.preventDefault();
    this.filterToggleTarget.classList.toggle('active');
    if (this.hasFilterButtonToggleTarget) this.filterButtonToggleTarget.classList.toggle('active');
    this.dropdownsTarget.classList.toggle('active');
  }
}

Filter.targets = ['filters', 'dropdowns', 'filterToggle', 'filterButtonToggle'];

export default Filter;